import { defineStore } from 'pinia'

export const usePlayGame = defineStore('PlayGame', {
  actions: {
    playNow() {
      // Read the URL, not `@/router`: importing the router here pulls `createWebHistory` (which needs
      // `window`) into the Node-side crawl script through routes -> MainMenu -> PlayNowButton.
      const isMSCW = window.location.pathname.includes('/mscw')
      if (isMSCW) {
        window.nexon.play('mscw')
      } else {
        window.nexon.play()
      }
    },
  },
})
